import { render, staticRenderFns } from "./AuthPage.vue?vue&type=template&id=7bb9c608"
import script from "./AuthPage.vue?vue&type=script&lang=js"
export * from "./AuthPage.vue?vue&type=script&lang=js"
import style0 from "./AuthPage.vue?vue&type=style&index=0&id=7bb9c608&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports